import { render, staticRenderFns } from "./NavbarToggleButton.vue?vue&type=template&id=2b923d18&"
import script from "./NavbarToggleButton.vue?vue&type=script&lang=ts&"
export * from "./NavbarToggleButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports